import AppendRoot from '@component/appendRoot'
import useMarker from './useMarker'
import MapboxPopupBase from './basePopup'
import { useCallback, useEffect } from 'react'
import BaseMarkerContext from './context'
import { assign, isBoolean, isFunction, isUndefined } from 'lodash-es'

const schoolPopupOffset = {
  top: [0, 20],
  bottom: [0, -20],
  left: [20, 0],
  right: [-20, 0],
}
export default function MapboxMarkerBase({
  lng,
  lat,
  id,
  opts,
  children,
  popup,
  popupOps,
  onAddedPopup,
  onAdded,
  onMouseEnter,
  onMouseLeave,
}) {

  const { box, marker } = useMarker({ lng, lat, id, element: true, opts })
  const togglePopup = useCallback(show => {
    if (!marker || !popup) return

    if (isUndefined(show)) {
      marker.togglePopup()
    } else if (isBoolean(show)) {
      const popup = marker.getPopup()
      if (!popup) return
      if (show) {
        if (!popup.isOpen()) marker.getPopup()
      } else {
        popup.remove()
      }
    }

  }, [marker, popup])

  useEffect(() => {
    if (!marker || !isFunction(onAdded)) return
    onAdded(marker)
  }, [marker, onAdded])

  useMouseEvent(marker, 'mouseenter', onMouseEnter)
  useMouseEvent(marker, 'mouseleave', onMouseLeave)
  return (
    <BaseMarkerContext.Provider value={{ togglePopup, marker }}>
      <AppendRoot container={box}>
        {children}
      </AppendRoot>
      {popup && <MapboxPopupBase lng={lng} lat={lat} marker={marker} onLoad={onAddedPopup} ops={assign({ offset: schoolPopupOffset, className: '!max-w-full' }, popupOps)}>{popup}</MapboxPopupBase>}
    </BaseMarkerContext.Provider>
  )
}

function useMouseEvent(marker, eventName, listener) {

  useEffect(() => {
    if (!marker || !isFunction(listener)) return

    const callback = event => listener(event, marker)

    const el = marker.getElement()
    el.addEventListener(eventName, callback)

    return () => {
      el.removeEventListener(eventName, callback)
    }
  }, [marker, eventName, listener])

}